import React from 'react';
import { PerpMarketConfig } from '@velocity-exchange/sdk';
import { UIMarket } from '@velocity-exchange/common';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import Select from 'src/components/primitives/Select/Select';
import useSelect from 'src/components/primitives/Select/hooks/useSelect';

interface Props {
	options: PerpMarketConfig[];
}

export default function SettleSelect({ options: optionsFromProps }: Props) {
	const setDrawerStore = useDrawersStore((s) => s.set);

	const options = optionsFromProps.map((option) => ({
		value: option.marketIndex,
		label: `Settle ${option.symbol} P&L Pool`,
	}));

	// Dont actually select it, just open the market details panel.
	const handleChange = (newSelection: number) => {
		setDrawerStore((s) => {
			s.marketDetails.uiMarket = UIMarket.createPerpMarket(newSelection);
			s.marketDetails.show = true;
			s.marketDetails.goToPnl = true;
		});
	};

	const {
		selectOptions,
		selectedOption,
		value,
		onValueChange,
		open,
		onOpenChange,
	} = useSelect({
		selectedValue: undefined,
		onSelectedValueChange: handleChange,
		options,
	});

	const disabled = options.length === 0;

	return (
		<Select.Root
			open={open}
			onOpenChange={onOpenChange}
			value={value}
			onValueChange={onValueChange}
			disabled={disabled}
		>
			<Select.Trigger disabled={disabled}>
				{selectedOption?.label ?? 'Settle P&L Pool'}
			</Select.Trigger>
			<Select.Options>
				{selectOptions.map((option) => (
					<Select.Option key={option.value} value={option.value.toString()}>
						{option.label}
					</Select.Option>
				))}
			</Select.Options>
		</Select.Root>
	);
}
